import React from "react";
import PropTypes from "prop-types";
import { HeaderButton } from "components/ui/HeaderButton";
import { VisuallyHidden } from "components/ui/VisuallyHidden";

import icon_calendar_256x256 from "components/../assets/images/icon_calendar_256x256.svg";
import icon_mail_256x256 from "components/../assets/images/icon_mail_256x256.svg";
import icon_drive_256x256 from "components/../assets/images/icon_drive_256x256.svg";

import { useStatusPopover } from "../StatusIcons/useStatusPopover";
import { PopoverMenu } from "./PopoverMenu";
import { PopoverContext } from "./Popovers/PopoverContext";

export function BConnectedButton({ children, count = false, service }) {
  const { isOpen, toggle, ref, triggerRef, close } = useStatusPopover();

  const icon = icons[service];
  const message = `${isOpen ? "Hide" : "Show"} your b${service}`;

  return (
    <div style={{ position: `relative` }}>
      <HeaderButton onClick={toggle} ref={triggerRef}>
        <img src={icon} width="22" height="22" />
        <VisuallyHidden>{message}</VisuallyHidden>
        {service !== "Drive" && (
          <span style={{ fontSize: `13px`, paddingRight: `var(--sm)` }}>
            {count ? count : "..."}
          </span>
        )}
      </HeaderButton>

      {isOpen && (
        <PopoverContext.Provider value={{ close }}>
          <PopoverMenu ref={ref}>{children}</PopoverMenu>
        </PopoverContext.Provider>
      )}
    </div>
  );
}

BConnectedButton.propTypes = {
  children: PropTypes.node,
  count: PropTypes.number,
  service: PropTypes.oneOf(["Mail", "Cal", "Drive"]),
};

const icons = {
  Mail: icon_mail_256x256,
  Cal: icon_calendar_256x256,
  Drive: icon_drive_256x256,
};
